import api from './api';

export interface EmailBroadcastData {
  recipient_type: 'all' | 'selected' | 'filtered';
  user_ids?: string[];
  filters?: {
    is_active?: boolean;
    is_admin?: boolean;
    tier_name?: string;
  };
  subject: string;
  message: string;
  email_type?: 'announcement' | 'marketing' | 'system' | 'newsletter';
}

export interface EmailBroadcastResponse {
  success: boolean;
  message: string;
  email_id: string;
  recipients_count: number;
  estimated_delivery_time?: string;
}

export interface EmailTemplate {
  id: string;
  name: string;
  subject: string;
  content: string;
  type: string;
  created_at: string;
}

const adminEmailService = {
  // Send broadcast email
  async sendBroadcastEmail(emailData: EmailBroadcastData): Promise<EmailBroadcastResponse> {
    const response = await api.post<EmailBroadcastResponse>('/admin/email/broadcast', emailData);
    return response.data;
  },

  // Get email templates
  async getEmailTemplates(): Promise<EmailTemplate[]> {
    const response = await api.get<EmailTemplate[]>('/admin/email/templates');
    return response.data;
  },

  // Create email template
  async createEmailTemplate(template: Omit<EmailTemplate, 'id' | 'created_at'>): Promise<EmailTemplate> {
    const response = await api.post<EmailTemplate>('/admin/email/templates', template);
    return response.data;
  },

  // Preview email (get recipient count)
  async previewEmail(emailData: Omit<EmailBroadcastData, 'subject' | 'message'>): Promise<{ recipients_count: number; sample_recipients: string[] }> {
    const response = await api.post('/admin/email/preview', emailData);
    return response.data;
  }
};

export default adminEmailService;